import { appConfig } from '../../../../../config/customization';

export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: appConfig.colors.tooltipColor,
    borderRadius: '5px',
    boxShadow: `2px 2px 5px ${appConfig.colors.gray}`
  },
  ul: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    listStyleType: 'none',
    padding: 0,
    margin: 10
  },
  li: {
    display: 'flex',
    alignItems: 'center'
  },
  content: {
    height: '12px',
    width: '12px',
    borderRadius: '10px'
  },
  arrow: {
    content: '',
    position: 'absolute',
    bottom: '0px',
    left: '55%',
    borderTop: `10px solid ${appConfig.colors.tooltipColor}`,
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent',
    borderBottom: '0px',
    marginLeft: '-20px',
    marginBottom: '-10px',
    zPosition: '-1'
  }
};
